import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/styles/landingCleanup.css";
import "@/styles/premium-motion.css";
import "@/styles/dropflow.css";
import "@/i18n";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
